<template>
  <div class="submit-message">
    <div class="title" :style="'color:' + landingPage.themeColor ">
      Enter your questions here.
    </div>
    <form @submit.prevent="submitMessage()">
      <input
          type="text"
          class="message-input text-field w-input"
          placeholder="Name"
          v-model="message.name"
      />
      <input
          type="text"
          class="message-input  name text-field w-input"
          placeholder="Email *"
          v-model="message.email"
          required
      />
      <input
          type="text"
          class="message-input text-field w-input"
          placeholder="Question *"
          v-model="message.message"
          required
      />
      <input class="message-input w-button submit" type="submit" :style="'background-color:' + landingPage.negativeColor + '; color:' + landingPage.themeColor " :value="submitButton"/>
    </form>
  </div>
</template>

<script>
export default {
  name: "SubmitQuestion",
  props: {
    landingPage: {},
    db: {},
  },
  data() {
    return {
      message: {
        name: "",
        email: "",
        message: ""
      },
      submitButton: "Submit Question"
    }
  },
  methods: {
    async submitMessage() {
      this.submitButton = "Submitting...."
      await this.db.collection("messages").post(this.message).then(() => {
        this.submitButton = "Submitted"
      })
      setTimeout(() => {
        this.submitButton = "Submit Another Message"
        this.message = {
          name: "",
          email: "",
          message: ""
        }
      }, 5000)
    }
  }
}
</script>

<style scoped>
.message-input {
  display: inline-block;
  width: 23%;
  margin: 10px;
  border: none;
  background: #f7f7f7 ;
}
.message-input.submit {
background: black;
  border-radius: 6px;
}
.submit-message {
  display: inline;
}
.submit-message > form {
  padding: 20px;
}

.title {
  padding-top: 10px;
}
@media screen and (max-width: 992px) {
  .message-input {
    display: block;
    width: 100%;
    margin: 0px;
    margin-bottom: 10px;
    border: none;
    background: #f7f7f7 ;
  }
  .message-input.submit {
    background: black;
    border-radius: 6px;
  }
  .submit-message {
    display: block;
  }
}
</style>